export const getTableConfig = ({ issuperadmin, canAddOrg, memberships = [] }) => ({
  columns: [
    {
      label: '',
      value: 'organization',
      width: '5%',
      align: 'center',
      type: 'count',
    },
    {
      label: 'Organization',
      value: 'organization',
      width: '15%',
      align: 'center',
      type: 'text',
      search: 'organization'
    },
    {
      label: 'Acct #',
      value: 'acctNumber',
      width: '15%',
      align: 'center',
      type: 'text',
      search: 'acctNumber'
    },
    {
      label: 'Contact Name',
      value: 'lastName',
      width: '15%',
      align: 'center',
      type: 'text',
      search: 'lastName'
    },
    {
      label: 'Street',
      value: 'street1',
      width: '15%',
      align: 'center',
      type: 'text'
    },
    {
      label: 'City',
      value: 'city',
      width: '15%',
      align: 'center',
      type: 'text'
    },
    {
      label: 'State',
      value: 'state',
      width: '20%',
      align: 'left',
      type: 'text'
    }
  ],
  queryName: '/org/getFiltered',
  onAddNew: issuperadmin ? '/orgs/add' : null,
  pageSize: 10,
  startNum: 1,

  buttons: (row) => {
    const membership = memberships.find(m =>
      String(m.orgId || m.organizationId || m.org?._id) === String(row._id)
    );

    const roles =
      membership?.roles ||
      membership?.orgRoles ||
      membership?.role ||
      [];

    const roleList = Array.isArray(roles)
      ? roles
      : [roles];

    const isOrgAdmin =
      roleList.includes('org:admin') ||
      roleList.includes('Admin');

    if (!isOrgAdmin && !issuperadmin) {
      return [];
    }

    return [
      { label: 'Edit', action: '/orgs/{_id}', color: 'blue' },
      issuperadmin ? { label: 'Delete', action: 'delete', color: 'red' } : {}
    ];
  }
});
